export enum rbacActions {

    GetDashboard = 'GetDashboard',
    ViewGettingStarted = 'ViewGettingStarted',

    ListDomainNames = 'ListDomainNames',
    GetDomainName = 'GetDomainName',
    CreateDomainName = 'CreateDomainName',
    UpdateDomainName = 'UpdateDomainName',
    DeleteDomainName = 'DeleteDomainName',

    ListRegistrars = 'ListRegistrars',
    GetRegistrar = 'GetRegistrar',
    CreateRegistrar = 'CreateRegistrar',
    UpdateRegistrar = 'UpdateRegistrar',
    DeleteRegistrar = 'DeleteRegistrar',

    ListTopLevelDomains = 'ListTopLevelDomains',
    GetTopLevelDomain = 'GetTopLevelDomain',
    CreateTopLevelDomain = 'CreateTopLevelDomain',
    UpdateTopLevelDomain = 'UpdateTopLevelDomain',
    DeleteTopLevelDomain = 'DeleteTopLevelDomain',

    ListServicePlans = 'ListServicePlans',
    GetServicePlan = 'GetServicePlan',
    CreateServicePlan = 'CreateServicePlan',
    UpdateServicePlan = 'UpdateServicePlan',
    DeleteServicePlan = 'DeleteServicePlan',

    ListSettings = 'ListSettings',
    GetSetting = 'GetSetting',
    UpdateSetting = 'UpdateSetting',
};

export const actions = Object.values(rbacActions);

